// 2026-04-10 21:47:26 +0700

export default {
  customerService: 'ផ្នែកសេវាអតិថិជន',
  insuranceProducts: 'ផលិតផលធានារ៉ាប់រង',
  carInsurance: 'ធានារ៉ាប់រងរថយន្ត',
  ourStory: 'រឿងរ៉ាវរបស់យើង',
  contactUs: 'ទំនាក់ទំនងយើង',
  aboutUs: 'អំពីយើង',
  privacyPolicy: 'គោលការណ៍ភាពឯកជន',
  termsAndConditions: 'ល័ក្ខខ័ណ្ឌនៃការប្រើប្រាស់',
  cancellationAndRefund: 'ទុកជាមោឃ និងសងប្រាក់វិញ',
  legal: 'ផ្លូវច្បាប់',
  sitemap: 'ផែនទីគេហទំព័រ',
  blog: 'ប្លុក',
  allRightsReserved: 'រក្សាសិទ្ធិគ្រប់យ៉ាង',
  signOut: 'ចាកចេញ',
  dashboard: 'ផ្ទាំងគ្រប់គ្រង',
  billing: 'វិក័យប័ត្រ',
  policy: 'ប័ណ្ណសន្យារ៉ាប់រង',
  password: 'ពាក្យសម្ងាត់',
  personalInfo: 'ព័ត៌មានផ្ទាល់ខ្លួន',
  account: 'គណនី',
  renewPolicy: 'បន្តបណ្ណសន្យារ៉ាប់រងរបស់អ្នក',
  claim: 'ទាមទារសំណង',
  discount: 'បញ្ចុះតម្លៃ',
  signIn: 'ចូល',
  request: 'ស្នើសុំ',
  update: 'ធ្វើបច្ចុប្បន្នភាព',
  personalInformation: 'ព័ត៌មាន​ផ្ទាល់ខ្លួន',
  edit: 'កែសម្រួល',
  claims: 'ការទាមទារសំណង',
  payNow: 'ទូទាត់ឥលូវនេះ',
  noData: 'គ្មាន​ទិន្នន័យ',
  viewMore: 'មើល​ច្រើន​ទៀត',
  expiryDate: 'កាលបរិច្ឆេទផុតកំណត់',
  policyNumber: 'លេខប័ណ្ណសន្យារ៉ាប់រង',
  orderNumber: 'លេខបញ្ជារទិញ',
  theInsured: 'អ្នកត្រូវបានធានារ៉ាប់រង',
  theInsuredPolicyholder: 'អ្នកត្រូវបានធានារ៉ាប់រង',
  claimForm: 'ពាក្យស្នើសុំទាមទារសំណង',
  insurer: 'ក្រុមហ៊ុនធានារ៉ាប់រង',
  policyType: 'ប្រភេទប័ណ្ណសន្យារ៉ាប់រង',
  yes: 'បាទ/ច៎ា',
  no: 'ទេ',
  yesHave: 'មាន',
  submit: 'ដាក់ស្នើរ',
  learnMore: 'សិក្សារបន្ថែម',
  recommendedReading: 'សូមណែនាំអោយអាន',
  compare: 'ប្រៀបធៀប',
  remove: 'ដកចេញ',
  removeAll: 'លុបទាំងអស់',
  back: 'ត្រលប់ក្រោយ',
  unknown: 'មិនស្គាល់',
  details: 'ព័ត៌មានលម្អិត',
  clickToViewDetails: 'ចុចដើម្បីមើលព័ត៌មានលម្អិត',
  status: 'ស្ថានភាព',
  renew: 'បន្តថ្មី',
  startDate: 'កាលបរិច្ឆេទមានប្រសិទ្ធភាព',
  endDate: 'កាលបរិច្ឆេទផុតកំណត់',
  proceedToPayment: 'បន្តទៅការទូទាត់',
  paySecurely: 'បង់ប្រាក់ដោយសុវត្ថិភាព',
  close: 'បិទ',
  coverage: 'ការធានារ៉ាប់រង',
  covers: 'ការធានារ៉ាប់រង',
  deductible: 'កំរិតមិនធ្វើសំណង',
  exclusion: 'ករណីមិនធានារ៉ាប់រង',
  privateCar: 'យានយន្តឯកជន',
  sendNow: 'ផ្ញើរឥលូវនេះ',
  periodOfInsurance: 'រយៈពេលនៃការធារារ៉ាប់រង',
  paidDate: 'ថ្ងៃ​បានបង់ប្រាក់',
  declaration: 'សេចក្តីប្រកាស',
  thirdPartyCover: 'ទំនួលខុសត្រូវលើតតិយជនតែប៉ុណ្ណោះ',
  comprehensiveCover: 'ទំនួលខុសត្រូវលើតតិយជន + ការខូចខាតផ្ទាល់ខ្លួន + ចោរកម្ម',
  compareQuotes: 'ប្រៀបធៀបសម្រង់តម្លៃ',
  endorsement: 'ការកែប្រែធានារ៉ាប់រង (Endorsement)',
  change: 'ផ្លាស់ប្តូរ',
  planType: 'ប្រភេទគម្រោង',
  loading: 'កំពុងដំណើរការ',
  quoteDetails: 'សម្រង់តម្លៃលម្អិត',
  youWillPay: 'អ្នកនឹងបង់ប្រាក់ចំនួន',
  planSummary: 'គម្រោងសង្ខេប',
  company: 'ក្រុមហ៊ុន',
  licensedBy: 'ផ្តល់អាជ្ញាបណ្ណដោយ',
  weAccept: 'យើងទទួលយក',
  mgaCoverSummary: 'បង្កើតដោយ MGA Asia Insurance Brokers ដែលជាក្រុមហ៊ុនជើងសាធានារ៉ាប់រងមានអជ្ញាបណ្ណក្នុងប្រទេសកម្ពុជា។',
  others: 'ផ្សេងៗ',
  brokerLicense: {
    label: 'លេខអាជ្ញាបណ្ណ',
    general: 'អាជ្ញាបណ្ណជើងសាធានារ៉ាប់រងទូទៅ លេខ ០៣៣ ន.ធ.ក',
    life: 'អាជ្ញាបណ្ណជើងសារធានារ៉ាប់រងអាយុជីវិត លេខ០០៣ ន.ធ.ក',
  },
  year: 'ឆ្នាំ',
  month: 'ខែ',
  policyTerm: 'រយៈពេលធានា',
  premiumPaymentTerm: 'រយៈពេលនៃការបង់បុព្វលាភធានារ៉ាប់រង',
  and: 'និង',
  sendOTP: 'ផ្ញើ OTP',
  enterWrongNumber: 'បញ្ចូលលេខខុស',
  articles: 'អត្ថបទ',
  benefit: 'អត្ថប្រយោជន៍',
  vehicle: 'យានជំនិះ',
  cambodia: 'ប្រទេសកម្ពុជា',
  noImage: 'គ្មានរូបភាព',
  rejectedReason: 'ហេតុផលត្រូវបានបដិសេធ',
  document: 'ឯកសារ',
  documentType: 'ប្រភេទឯកសារ',
  additionalDocuments: 'ឯកសារបន្ថែម',
  renewable: 'អាចកកើតឡើងវិញបាន។',
  claimable: 'អាចទាមទារបាន។',
  startedAt: 'បានចាប់ផ្តើមនៅ',
  endedAt: 'បានបញ្ចប់នៅ',
  followUs: 'តាមដានបណ្តាញសង្គមរបស់យើង',
  goHome: 'ទៅទំព័រដើម',
  delete: 'លុប',
  photos: 'រូបថត',
  managePhotos: 'គ្រប់គ្រងរូបថត',
  emergencyCall: 'សម្រាប់លេខទំនាក់ទំនងរបស់ក្រុមហ៊ុនធានារ៉ាប់រង {{hotline}} និង<br />លេខទំនាក់ទំនងក្រុមការងារ MGA Cover : 092-777-125 | 016-444-413',
  featuredIn: 'ត្រូវបានចុះផ្សាយនៅក្នុង',
  preview: 'មើលជាមុន',
  latestArticles: 'អត្ថបទថ្មីៗ',
  home: 'ទំព័រដើម',
  getQuote: 'ទទួលសម្រង់តម្លៃ',
  next: 'បន្ទាប់',
  required: 'ទាមទារ',
  buyNow: 'ទិញឥលូវនេះ',
  feature: 'លក្ខណៈពិសេស',
  myself: 'ខ្លួនខ្ញុំផ្ទាល់',
  myAge: 'អាយុ​ខ្ញុំ',
  spouse: 'ប្តី រឺ ប្រពន្ធ',
  spouseAge: 'អាយុប្តី រឺ ប្រពន្ធ',
  father: 'ឪពុក',
  fatherAge: 'អាយុឪពុក',
  mother: 'ម្ដាយ',
  motherAge: 'អាយុម្ដាយ',
  son: 'កូនប្រុស',
  sonAge: 'អាយុកូនប្រុស',
  daughter: 'កូនស្រី',
  daughterAge: 'អាយុកូនស្រី',
  role: 'តួនាទី',
  accountInformation: 'ព​ត៌​មាន​គណនី',
  review: 'ពិនិត្យ',
  summary: 'សង្ខេប',
  compareGuide: 'បន្ថែមសម្រង់តម្លៃរហូតដល់ {{max}} ដើម្បីប្រៀបធៀប',
  promotionDiscount: 'ការបញ្ចុះតម្លៃការផ្សព្វផ្សាយ',
  contactViaFacebook: 'ទំនាក់ទំនងយើងខ្ញុំតាមរយៈ Facebook',
  contactViaTelegram: 'ទំនាក់ទំនងយើងខ្ញុំតាមរយៈ Telegram',
  telephone: 'លេខទូរសព្ទ',
  sendQuoteToMyEmail: 'ផ្ញើសម្រង់តម្លៃនេះទៅអ៊ុីមែលរបស់ខ្ញុំ',
  me: 'ខ្ញុំ',
  premium: 'បុព្វលាភធានារ៉ាប់រង',
  copied: 'បានចម្លង',
  copyLink: 'ចម្លងតំណ',
  adminFee: 'ថ្លៃសេវារដ្ឋបាល',
  policyWording: 'ប័ណ្ណសន្យារ៉ាប់រងលម្អិត',
  planBrochure: 'ខិត្តប័ណ្ណគំរោង',
  premiumBreakdown: 'បុព្វលាភធានារ៉ាប់រងលម្អិត',
  thirdPartyCoverPremium: 'បុព្វលាភលើការធានាររ៉ាប់រងតតិយជន',
  ownDamageTheftCoverPremium: 'បុព្វលាភលើការធានារ៉ាប់រងការខូចខាតផ្ទាល់ខ្លួន (OD) / ចោរកម្ម',
  totalPremium: 'បុព្វលាភសរុប',
  totalPremiumKhr: 'បុព្វលាភសរុបគិតជារៀល',
  ownDamageTheftPremium: 'បុព្វលាភការខូចខាតផ្ទាល់ខ្លួន / ចោរកម្ម',
  thirdPartyPremium: 'បុព្វលាភភាគីទីបី',
  accidentToDriverPremium: 'បុព្វលាភគ្រោះថ្នាក់ដល់អ្នកបើកបរ',
  passengerLiabilityPremium: 'បុព្វលាភការទទួលខុសត្រូវអ្នកដំណើរ',
  policyOverview: 'ទិដ្ឋភាពទូទៅនៃបណ្ណសន្យារ៉ាប់រង',
  newClaim: 'ដាក់ពាក្យទាមទារសំណងថ្មី',
  requestDate: 'កាលបរិច្ឆេទស្នើរសុំ',
  planDetails: 'គម្រោងលំអិត',
  note: 'ចំណាំ',
  policyDetails: 'ព័ត៌មានលម្អិតអំពីបណ្ណសន្យារ៉ាប់រង',
  claimDetails: 'ព័ត៌មានលម្អិតការទាមទារ',
  notSet: 'មិនបានកំណត់',
  noteToInsurer: 'ចំណាំទៅក្រុមហ៊ុនធានារ៉ាប់រង',
  fillPolicyDetails: 'បំពេញព័ត៌មានលម្អិតអំពីបណ្ណសន្យារ៉ាប់រង',
  cancel: 'បោះបង់',
  tpl: 'ទំនួលខុសត្រូវរបស់ភាគីទីបី (TPL)',
  coverValueIdv: 'តម្លៃរ៉ាប់រង IDV',
  od: 'ការខូចខាតផ្ទាល់ខ្លួន (OD)',
  theft: 'ចោរកម្ម',
  ad: 'គ្រោះថ្នាក់ដល់អ្នកបើកបរ (AD)',
  pl: 'ទំនួលខុសត្រូវអ្នកដំណើរ (PL)',
  flood: 'ទឹកជំនន់',
  srcc: 'កូដកម្ម កុប្បកម្ម ឬការបះបោរ',
  included: 'រួមបញ្ចូល',
  instance: 'ភ្លាមៗ',
  frontlineUser: 'ផ្នែកគាំទ្រជួរមុខ',
  policyUnderReview: 'បច្ចុប្បន្ន Policy របស់អ្នកកំពុងស្ថិតក្រោមការត្រួតពិនិត្យ ដោយសារចម្លើយរបស់អ្នក ត្រូវបានតម្រូវអោយមានការវាយតម្លៃដោយអ្នកជំនាញជាមុន។ ដំណើរការនេះនឹងចំណាយពេលប្រហែល បីថ្ងៃ។ យើងនឹងទាក់ទងអ្នកនៅពេលយើងទទួលបានការបញ្ជាក់ពីក្រុមហ៊ុនធានារ៉ាប់រង។',
  enterDetail: 'បញ្ចូលព័ត៌មានលម្អិត',
  specifyProblem: 'សូមបញ្ជាក់បញ្ហា',
  all: 'ទាំងអស់',
  proof: 'ភស្តុតាង',
  corporateInsurance: 'ធានារ៉ាប់រងសាជីវកម្ម',
  information: 'ព័ត៌មាន',
  effectiveDate: 'កាលបរិច្ឆេទមានប្រសិទ្ធភាព',
  expirationDate: 'កាលបរិច្ឆេទផុតកំណត់',
  member: 'សមាជិក',
  downloadInvoice: 'ទាញយកវិក្កយបត្រ',
  customerConsent: 'ការយល់ព្រមរបស់អតិថិជន',
  description: 'ការពិពណ៌នា',
  policyTemplate: 'ទម្រង់សន្យារ៉ាប់រង',
  confirm: 'បញ្ជាក់',
  fillOwnerDetails: 'បំពេញព័ត៌មានលម្អិតរបស់ម្ចាស់',
  fillDescriptionDetails: 'បំពេញសេចក្ដីលម្អិតការពិពណ៌នា',
  custom: 'ប្ដូរតាមបំណង',
  reset: 'កំណត់ឡើងវិញ',
  payByCash: 'បង់ជាសាច់ប្រាក់',
  renewal: 'ការបន្ត',
  expiredSoon: 'ផុតកំណត់ឆាប់ៗនេះ',
  noDocument: 'គ្មានឯកសារ',
  orderType: 'ប្រភេទបញ្ជាទិញ',
  otpLink: 'តំណភ្ជាប់ OTP',
  promotionCode: 'លេខកូដបញ្ចុះតម្លៃ',
  apply: 'អនុវត្ត',
  addUser: 'បន្ថែមអ្នកប្រើប្រាស់',
  customType: 'ប្រភេទផ្ទាល់ខ្លួន',
  user: 'អ្នកប្រើប្រាស់',
  save: 'រក្សាទុក',
  saving: 'កំពុងរក្សាទុក',
  loadMore: 'ផ្ទុកបន្ថែម',
  employee: 'បុគ្គលិក',
  createdDate: 'កាលបរិច្ឆេទបង្កើត',
  import: 'នាំចូល',
  addImport: 'បន្ថែមការនាំចូល',
  success: 'ជោគជ័យ',
  fail: 'បរាជ័យ',
  error: 'កំហុស',
  skip: 'រំលង',
  healthPlan: 'ផែនការសុខភាព',
  csvFile: 'ឯកសារ CSV',
  addDocuments: 'បន្ថែមឯកសារ',
  active: 'សកម្ម',
  inactive: 'អសកម្ម',
  importType: 'នាំចូលប្រភេទ',
  claimNumber: 'លេខទាមទារសំណង',
  benefitSchedule: 'តារាងអត្ថប្រយោជន៍',
  limitAmount: 'ចំនួនកំណត់',
  remainingLimitAmount: 'ចំនួនកំណត់នៅសល់',
  data: 'ទិន្នន័យ',
  result: 'លទ្ធផល',
  family: 'គ្រួសារ',
  searchCorporateMember: 'ស្វែងរកបុគ្គលិកក្រុមហ៊ុន',
  billingType: 'ប្រភេទវិក័យប័ត្រ',
  search: 'ស្វែងរក',
  refundedPremium: 'បុព្វលាភដែលបានសងវិញ',
  hospitalNetwork: 'បណ្តាញមន្ទីរពេទ្យ',
  garageNetwork: 'បណ្តាញហាងជួសជុលរថយន្ត',
  memberSince: 'សមាជិកចាប់តាំងពី',
  creator: 'អ្នកបង្កើត',
  type: 'ប្រភេទ',
  insuranceType: 'ប្រភេទធានារ៉ាប់រង',
  add: 'បន្ថែម',
  notFound: 'រកមិនឃើញ',
  uploadDocuments: 'អាប់ឡូតឯកសារ',
  print: 'បោះពុម្ព',
  memberName: 'ឈ្មោះសមាជិក',
  plan: 'គម្រោង',
  subBenefit: 'អត្ថប្រយោជន៍រង',
  maxLimitAmount: 'ចំនួនទឹកប្រាក់កំណត់អតិបរមា',
  insurancePolicy: 'គោលនយោបាយធានារ៉ាប់រង',
  newInsurancePolicy: 'គោលនយោបាយធានារ៉ាប់រងថ្មី',
  policyInformation: 'ព័ត៌មាន​គោលការណ៍',
  memberId: 'លេខសម្គាល់សមាជិក',
  searchInsured: 'ស្វែងរកត្រូវបានធានារ៉ាប់រង',
  newPolicy: 'គោលនយោបាយថ្មី',
  insuranceClaimProcedure: 'ដំណើរការទាមទារសំណងធានារ៉ាប់រង',
  requestDocuments: 'ស្នើសុំឯកសារ',
  sending: 'កំពុងផ្ញើ...',
  title: 'ចំណងជើង',
  body: 'ខ្លឹមសារ',
  requester: 'អ្នកស្នើសុំ',
  downloadClaimSubmission: 'ទាញយកការដាក់ស្នើការទាមទារ',
  accumulatedPaidAmount: 'ចំនួនទឹកប្រាក់ដែលបានទូទាត់',
  companyName: 'ក្រុមហ៊ុន',
  primaryInsured: 'អ្នកត្រូវបានធានារ៉ាប់រងចម្បង',
  searchByMemberIdOrName: 'ស្វែងរកតាមលេខសមាជិក ឬឈ្មោះ',
  claimAmount: 'ចំនួនទាមទារសំណង',
  insurerMemberId: 'លេខសមាជិកក្រុមហ៊ុនធានារ៉ាប់រង',
};
